export enum ERequestStatus {
  Idle,
  Loading,
  Succeeded,
  Failed
}
